import { render } from "./SeatInformation.vue?vue&type=template&id=2b83923a&scoped=true"
import script from "./SeatInformation.vue?vue&type=script&lang=js"
export * from "./SeatInformation.vue?vue&type=script&lang=js"

import "./SeatInformation.vue?vue&type=style&index=0&id=2b83923a&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b83923a"]])

export default __exports__